module.exports = __webpack_public_path__ + "img/img_sec_ticketintro_01.c55b55e5.png";